import { List } from '@/components/highlighted-feed-wrapper/highlighted-feed-wrapper.tsx';
import { PolymorphicPostCard } from '@/components/polymorphic-post-card.tsx';
import { FeedItem, PostFeedProps } from '@/components/post-feed/post-feed.tsx';
import { useRedesign } from '@/feature-flags/redesign/use-redesign.ts';
import { StreamEventList, StreamEventRowV2 } from './stream-event-row-v2.tsx';

const feedPropsV1: Pick<PostFeedProps, 'components'> = {
  components: { List },
};

const feedPropsV2: Pick<PostFeedProps, 'components' | 'itemContent'> = {
  components: { List: StreamEventList },
  itemContent: (_idx: number, post: FeedItem) =>
    post.__typename === 'StreamPost' ? (
      <StreamEventRowV2 post={post} />
    ) : (
      <PolymorphicPostCard post={post} linkToPost />
    ),
};

export const useStreamFeedProps = () =>
  useRedesign() ? feedPropsV2 : feedPropsV1;
